import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { ICustomFieldValues } from '../../../shared/interfaces/custom-field.interface';
import { trackById } from '../../../shared/util/track-by.util';

@Component({
  selector: 'lum-sales-order-custom-field-cell-renderer',
  templateUrl: './sales-order-custom-field-cell-renderer.component.html',
  styleUrls: ['./sales-order-custom-field-cell-renderer.component.scss'],
})
export class SalesOrderCustomFieldCellRendererComponent
  implements ICellRendererAngularComp
{
  customFieldValues :ICustomFieldValues[] = [];
  limit :number = 1;
  trackById = trackById;

  agInit(params :ICellRendererParams) :void {
    this.customFieldValues = params.data?.customFieldValues || [];
  }

  refresh(params :any) :boolean {
    return false;
  }

  showMore() :void {
    this.limit = this.customFieldValues.length;
  }

  showLess() :void {
    this.limit = 1;
  }
}
